export const screenSizes = {
  large: 1440,
  largeMedium: 1201,
  medium: 993,
  mediumSmall: 761,
  small: 577,
};
